export default __webpack_public_path__ + "static/media/hmd_background_s2.30a2fe14.jpg";